/**
 * CHROMA HOMEPAGE HERO
 * Trust signal mobile slider + neural network aurora
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var heroSections = document.querySelectorAll('.hero-section');
    heroSections.forEach(function(section) {
      initTrustSlider(section.id);
      initHeroNeuralNetwork(section.id);
    });
  });

  /**
   * TRUST SIGNAL SLIDER — mobile only
   * Swipeable cards with pink dot pagination
   */
  function initTrustSlider(sectionId) {
    var grid = document.getElementById('heroTrust-' + sectionId);
    if (!grid) return;

    var slider = grid.closest('.hero-trust-slider');
    var dots = slider ? slider.querySelectorAll('.hero-trust-dot') : [];
    var items = grid.querySelectorAll('.trust-item');

    if (!dots.length || items.length <= 1) return;

    var isMobile = function() { return window.matchMedia('(max-width: 639px)').matches; };
    var currentIndex = 0;

    function goToSlide(index) {
      if (!isMobile()) return;
      currentIndex = Math.max(0, Math.min(index, items.length - 1));
      var offset = items[currentIndex].offsetLeft - grid.offsetLeft;
      grid.style.transform = 'translateX(-' + offset + 'px)';

      dots.forEach(function(dot, i) {
        var isActive = i === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(dot.dataset.index, 10));
      });
    });

    // Swipe support
    var startX = 0;
    var isDragging = false;

    grid.addEventListener('touchstart', function(e) {
      if (!isMobile()) return;
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    grid.addEventListener('touchend', function(e) {
      if (!isDragging || !isMobile()) return;
      isDragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goToSlide(currentIndex + (diff > 0 ? 1 : -1));
      }
    });

    // Reset on resize to desktop
    window.addEventListener('resize', function() {
      if (!isMobile()) {
        grid.style.transform = '';
      }
    });
  }

  /**
   * NEURAL NETWORK — thin aurora strip at top of hero
   * Fewer nodes + shorter canvas to fit 150px band
   */
  function initHeroNeuralNetwork(sectionId) {
    var canvas = document.getElementById('heroNeuralCanvas-' + sectionId);
    if (!canvas) return;

    var aurora = canvas.parentElement;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ctx = canvas.getContext('2d');

    var rs = getComputedStyle(document.documentElement);
    var palette = [
      rs.getPropertyValue('--color-primary-rgb').trim()   || '123,44,191',
      rs.getPropertyValue('--color-secondary-rgb').trim() || '6,182,212',
      rs.getPropertyValue('--color-accent-rgb').trim()    || '255,0,110'
    ];

    var NODE_COUNT    = 24;
    var CONNECT_DIST  = 160;
    var MOUSE_RADIUS  = 140;
    var ATTRACT_STR   = 0.045;
    var DAMPING       = 0.82;
    var EDGE_MARGIN   = 10;
    var EDGE_STR      = 0.08;

    var mouseX = -9999, mouseY = -9999;
    var rafId = null, visible = false;

    function resize() {
      canvas.width  = aurora.offsetWidth;
      canvas.height = aurora.offsetHeight;
    }

    function makeNode() {
      var r     = Math.random() * 30 + 10;
      var bx    = r + Math.random() * Math.max(1, canvas.width  - 2 * r);
      var by    = r + Math.random() * Math.max(1, canvas.height - 2 * r);
      var angle = Math.random() * Math.PI * 2;
      var speed = (Math.random() * 0.006 + 0.003) * (Math.random() < 0.5 ? 1 : -1);
      return {
        bx: bx, by: by,
        x: bx + Math.cos(angle) * r,
        y: by + Math.sin(angle) * r,
        angle: angle, r: r, speed: speed,
        vx: 0, vy: 0,
        size: Math.random() * 1.2 + 1.5,
        color: palette[Math.floor(Math.random() * palette.length)]
      };
    }

    resize();
    var nodes = [];
    for (var i = 0; i < NODE_COUNT; i++) nodes.push(makeNode());

    function update() {
      for (var i = 0; i < nodes.length; i++) {
        var n  = nodes[i];
        var dx = mouseX - n.x;
        var dy = mouseY - n.y;
        var d  = Math.sqrt(dx * dx + dy * dy);

        if (d < MOUSE_RADIUS) {
          var force = (1 - d / MOUSE_RADIUS) * ATTRACT_STR;
          n.vx = (n.vx + dx * force) * DAMPING;
          n.vy = (n.vy + dy * force) * DAMPING;
          // Edge repulsion
          if (n.x < EDGE_MARGIN)                n.vx += (EDGE_MARGIN - n.x) * EDGE_STR;
          if (n.x > canvas.width - EDGE_MARGIN)  n.vx -= (n.x - (canvas.width - EDGE_MARGIN)) * EDGE_STR;
          if (n.y < EDGE_MARGIN)                n.vy += (EDGE_MARGIN - n.y) * EDGE_STR;
          if (n.y > canvas.height - EDGE_MARGIN) n.vy -= (n.y - (canvas.height - EDGE_MARGIN)) * EDGE_STR;
          n.x += n.vx;
          n.y += n.vy;
        } else {
          n.angle += n.speed;
          var tx = n.bx + Math.cos(n.angle) * n.r;
          var ty = n.by + Math.sin(n.angle) * n.r;
          n.x += (tx - n.x) * 0.06;
          n.y += (ty - n.y) * 0.06;
          n.vx *= 0.9;
          n.vy *= 0.9;
        }
      }
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (var i = 0; i < nodes.length; i++) {
        for (var j = i + 1; j < nodes.length; j++) {
          var dx   = nodes[i].x - nodes[j].x;
          var dy   = nodes[i].y - nodes[j].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < CONNECT_DIST) {
            ctx.beginPath();
            ctx.moveTo(nodes[i].x, nodes[i].y);
            ctx.lineTo(nodes[j].x, nodes[j].y);
            ctx.strokeStyle = 'rgba(' + nodes[i].color + ', ' + ((1 - dist / CONNECT_DIST) * 0.25) + ')';
            ctx.lineWidth = 0.7;
            ctx.stroke();
          }
        }
      }

      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var grd = ctx.createRadialGradient(n.x, n.y, 0, n.x, n.y, n.size * 3);
        grd.addColorStop(0, 'rgba(' + n.color + ', 0.2)');
        grd.addColorStop(1, 'rgba(' + n.color + ', 0)');
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.size * 3, 0, Math.PI * 2);
        ctx.fillStyle = grd;
        ctx.fill();

        ctx.beginPath();
        ctx.arc(n.x, n.y, n.size, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(' + n.color + ', 0.85)';
        ctx.fill();
      }
    }

    function loop() {
      update();
      draw();
      rafId = requestAnimationFrame(loop);
    }

    function start() { if (!rafId) loop(); }
    function stop()  { if (rafId) { cancelAnimationFrame(rafId); rafId = null; } }

    aurora.addEventListener('mousemove', function(e) {
      var rect = canvas.getBoundingClientRect();
      mouseX = e.clientX - rect.left;
      mouseY = e.clientY - rect.top;
    });
    aurora.addEventListener('mouseleave', function() {
      mouseX = -9999;
      mouseY = -9999;
    });

    window.addEventListener('resize', function() {
      var oldW = canvas.width || 1;
      var oldH = canvas.height || 1;
      resize();
      var sx = canvas.width / oldW;
      var sy = canvas.height / oldH;
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].bx *= sx; nodes[i].by *= sy;
        nodes[i].x  *= sx; nodes[i].y  *= sy;
      }
    });

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        visible = entry.isIntersecting;
        if (entry.isIntersecting) start(); else stop();
      });
    }, { threshold: 0.1 });
    io.observe(aurora);

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) stop();
      else if (visible) start();
    });
  }

})();
